// components/SkeletonVideoCard.jsx
import React from 'react';
import './Skeleton.css';

export default function SkeletonVideoCard() {
    return (
        <div className="skeleton-video-card">
            <div className="skeleton thumbnail" />
            <div className="skeleton text-line short" />
            <div className="skeleton text-line" />
        </div>
    );
}
